import { Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MainContent from '../../../components/Generic/MainContent';
import CreatePageButton from '../components/CreatePage';
import PageList from '../components/PageList';

const DynamicPages: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <MainContent maxH="100svh" overflowY="auto">
        <Heading mb="48px" color="#469BFF" fontFamily="Poppins">
          {t('pagesTitle')}
        </Heading>

        <CreatePageButton maxW="196px" py={2} />

        <PageList />
      </MainContent>
    </>
  );
};

export default DynamicPages;
